<script>
import CodeSendNewForm from 'components/views/auth/forms/code/SendNew.svelte';
import CodeResendEmailForm from 'components/views/auth/forms/code/ResendEmail.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import SvelteSeo from 'svelte-seo';


let msg_show = false;
let msg_type;
let msg_text;

let show_resend_option = false;

let email_to;

</script>



<style>

#code-send-new-card {
	
}

</style>


<SvelteSeo
	title='Send New Code | AHG Coaches Portal'
	description='Send New Code!'
/>


<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Get new code
			</p>

		</div>

	</div>
	
</section>



<section class="section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-5-desktop is-8-tablet is-12-mobile">

				<MsgCard bind:msg_show={msg_show} bind:msg_type={msg_type} bind:msg_text={msg_text} />

				{#if !show_resend_option}

				<div class="card form-card" id="code-send-new-card">

					<div class="card-content">

						<!-- <CodeResendEmailForm bind:msg_show={msg_show} bind:msg_type={msg_type} bind:msg_text={msg_text} {email_to} /> -->

						<CodeSendNewForm bind:msg_show={msg_show} bind:msg_type={msg_type} bind:msg_text={msg_text} bind:show_resend_option={show_resend_option} bind:email_to={email_to} />

					</div>

				</div>

				{/if}

			</div>

		</div>

	</div>
	
</section>




